<script lang="ts" setup>
defineProps<{
  text?: string
  disabled?: boolean
  delayDuration?: number

  triggerClass?: string
  contentClass?: string
  arrowClass?: string
}>()
</script>

<template>
  <TooltipProvider :delay-duration="delayDuration || 250">
    <TooltipRoot>
      <TooltipTrigger :class="triggerClass">
        <slot />
      </TooltipTrigger>

      <TooltipContent
        class="z-1000 px-3 py-10px max-w-350px select-none rounded-5px bg-shade-light break-words text-sm text-neutral-500 elevation-bottom-4 will-change-transform will-change-opacity data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-50 data-[state=delayed-open]:zoom-in-90 data-[state=closed]:animate-out data-[state=closed]:fade-out-50 data-[state=closed]:zoom-out-90"
        :class="contentClass"
        :side-offset="5"
      >
        <slot name="content">
          {{ text }}
        </slot>
        <TooltipArrow class="fill-white" :class="arrowClass" :width="8" />
      </TooltipContent>
    </TooltipRoot>
  </TooltipProvider>
</template>
